import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getPasswordInitialValues = createSelector(
    getModel,
    (model) => model.passwordInitialValues,
);

export const getSaveItem = createSelector(getModel, (model) => model.saveItem);

export const getIsSavingItem = createSelector(
    getSaveItem,
    (saveItem) => saveItem.isSaving,
);
export const getSaveItemErrors = createSelector(
    getSaveItem,
    (saveItem) => saveItem.errors,
);

export const getDeleteItem = createSelector(
    getModel,
    (model) => model.deleteItem,
);

export const getIsDeletingItem = createSelector(
    getDeleteItem,
    (deleteItem) => deleteItem.isDeleting,
);

export const getDeleteItemErrors = createSelector(
    getDeleteItem,
    (deleteItem) => deleteItem.errors,
);

export const getFetchUsers = createSelector(
    getModel,
    (model) => model.fetchUsers,
);

export const getIsFetchingUsers = createSelector(
    getFetchUsers,
    (fetchItems) => fetchItems.isFetching,
);

export const getFetchUsersData = createSelector(
    getFetchUsers,
    (fetchItems) => fetchItems?.data?.data,
);

export const getFetchUsersPagination = createSelector(
    getFetchUsers,
    (fetchItems) => fetchItems?.data?.pagination,
);

export const getFetchUsersErrors = createSelector(
    getFetchUsers,
    (fetchItems) => fetchItems.errors,
);

export const getIsOpenModalProduct = createSelector(
    getModel,
    (model) => model.isOpenModalProduct,
);

export const getIsOpenModalPassword = createSelector(
    getModel,
    (model) => model.isOpenModalPassword,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);
